import { withStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const CustomTextField = withStyles({
  root: {
    fontSize: 20,

    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      height: 48,
    },
    '& .MuiOutlinedInput-input': {
      marginRight: 0,
      paddingLeft: 5,
      fontSize: 16,
    },
    '& .Mui-disabled': {
      '&.MuiOutlinedInput-root': {
        backgroundColor: '#f6f6f6',
      },
    },
  },
})(TextField);
const CustomTitleLabel = withStyles((theme) => ({
  root: {
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 4,
    color: '#666666',
  },
}))(Typography);

const StationForm = ({ errors, setFormValue, formValue }) => {
  const onChange = (key) => (e) => {
    if (!setFormValue) return;
    setFormValue({
      ...formValue,
      [key]: e.target.value,
    });
  };

  return (
    <Box px={2.25} py={2}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <CustomTitleLabel>Name</CustomTitleLabel>
          <CustomTextField
            fullWidth
            variant="outlined"
            placeholder="Enter name"
            error={!!errors.name}
            helperText={errors.name}
            value={formValue.name}
            onChange={onChange('name')}
          />
        </Grid>

        <Grid item xs={6}>
          <CustomTitleLabel>Station short name</CustomTitleLabel>
          <CustomTextField
            fullWidth
            variant="outlined"
            placeholder="Enter name"
            error={!!errors.shortName}
            helperText={errors.shortName}
            value={formValue.shortName}
            onChange={onChange('shortName')}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StationForm;
